module.exports = __webpack_public_path__ + "static/media/400001_02.77ad5599.png";